import * as React from "react";

import usePlaceOrder from "@payment-client/hooks/UsePlaceOrder";
import useProcessOrder from "@payment-client/hooks/useProcessOrder";
import { CheckoutContext } from "@swiggy-private/checkout-core";
import { PlaceOrderContext } from "@payment-client/contexts/PlaceOrderContext";

export function OrderContextProvider(props: { children: React.ReactNode }): React.ReactElement {
    const checkoutContextValue = React.useContext(CheckoutContext);
    const [processingOrder] = useProcessOrder(checkoutContextValue);
    const [{ placeOrderInProgress, placeOrderData }, setPlaceOrder, isPlaceOrderHookMounted] = usePlaceOrder();

    const placeOrderContextValue = React.useMemo(
        () => ({
            placeOrderData,
            placeOrderInProgress,
            processingOrder,
            doPlaceOrder: setPlaceOrder,
            isPlaceOrderHookMounted,
        }),
        [placeOrderData, placeOrderInProgress, processingOrder, setPlaceOrder, isPlaceOrderHookMounted],
    );

    return <PlaceOrderContext.Provider value={placeOrderContextValue}>{props.children}</PlaceOrderContext.Provider>;
}
